import joachimPic from "@/public/images/artists/joachim.jpg";
import { Artist } from "@/types/types";

export const joachim = {
  id: "272",
  name: "Joachim",
  image: joachimPic,
  description: `Joachim's voice has a distinct, textured timbre that fits naturally in indie rock, with a relaxed energy that gives his sound a laid-back, recognizable character.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fjoachim-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Rock", "Indie", "Funk"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 50,
        high: 71,
      },
      sweetSpot: 61,
    },
  },
} as const satisfies Artist;
